/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function Select({ options, selectIcon, value: inputValue, ...props }) {
  const classes = useStyles();
  return (
    <TextField className={classes.select} value={inputValue} variant="outlined" fullWidth select SelectProps={{ MenuProps: { disableScrollLock: true } }} {...props}>
      {options.map((option) => {
        if (typeof option === 'string') {
          return (
            <MenuItem key={option} value={option}>
              {selectIcon && inputValue === option && <> {selectIcon}</>}
              {option}
            </MenuItem>
          );
        }
        const { value, label } = option;
        return (
          <MenuItem key={value} value={value}>
            {selectIcon && inputValue === value && <> {selectIcon}</>}
            {label}
          </MenuItem>
        );
      })}
    </TextField>
  );
}

Select.propTypes = {
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  ...TextField.propTypes,
};

Select.defaultProps = {
  options: [],
};

export default Select;
